// Protection of selling personal information under California or Nevada law
export const CCPA_STATE_COOKIE_NAME = 'dnsmpi';

export const MESO_AD_EVENTS = {
    PASS: 'AD-LOAD-PASS',
    FAIL: 'AD-LOAD-FAIL',
    EMPTY: 'AD-LOAD-EMPTY',
};

export const MESO_SLOT_STATUSES = {
    LOADING: 'loading',
    FAILED: 'failed',
    LOADED: 'loaded',
    RENDERING_FAILURE: 'RENDERING-FAILURE'
};


export const ADS_LOADER_PROD = {
    adsLoader: [
        {
            src: 'https://www.uciservice.com/assets/meso-loaders/ads-loader.js',
            id: 'ads-loader',
            type: 'module'

        },
        {
            src: 'https://www.uciservice.com/assets/meso-loaders/ads-loader.es5.js',
            id: 'ads-loader-es5',
            defer: true,
            noModule: true
        }
    ],
    adBlockTest: 'https://www.uciservice.com/assets/meso-loaders/expads-blocked.js',
};

export const ADS_LOADER_DEVELOPMENT = {
    adsLoader: [
        {
            src: 'https://www.uciservice.com/assets-int/meso-loaders/ads-loader.js',
            id: 'ads-loader',
            type: 'module'

        },
        {
            src: 'https://www.uciservice.com/assets-int/meso-loaders/ads-loader.es5.js',
            id: 'ads-loader-es5',
            defer: true,
            noModule: true
        }
    ],
    adBlockTest: 'https://www.uciservice.com/assets-int/meso-loaders/expads-blocked.js'
};
